import React from 'react';
import MethodsCatalogueTable from './MethodsCatalogueTable';
import CreateDepositMethodModal from './CreateDepositMethodModal';

interface DepositMethodsTableProps {
  siteId: string | number;
}

const DepositMethodsTable: React.FC<DepositMethodsTableProps> = ({ siteId }) => (
  <MethodsCatalogueTable
    siteId={siteId}
    direction="deposit"
    CreateModal={CreateDepositMethodModal}
  />
);

export default DepositMethodsTable;
